/**
 * @typedef {Object} YearSelectOption
 * @property {string} label
 * @property {number} value
 */

/**
 *
 * @param {number} value
 *
 * @returns {YearSelectOption}
 */
export function getYearSelectOption(value) {
  return {
    label: String(value),
    value,
  }
}

/**
 * @param {number} minValue
 * @param {number} maxValue
 *
 * @returns {YearSelectOption[]}
 */
export function getYearSelectOptions(minValue, maxValue) {
  return Array.from({ length: maxValue - minValue + 1 }, (_, index) =>
    getYearSelectOption(maxValue - index)
  )
}
